import React from 'react'
import { func, object, bool, number } from 'prop-types'

import classNames from 'classnames/bind'

import Input from 'coact/Input'
import Select from 'coact/Select'

import LensSpec from './LensSpec'


function ItemEditor (props) {
  const {
    index,
    value,
    spliter,
    style,
    /* copyItem,
    deleteItem, */
    toggleFullFeatures,
    full,
    copy,
    remove,
  } = props
  const cx = classNames.bind(style)
  const isLens = value.productRef && (value.productRef.type === 'B')
  const toggleFullFeaturesBtn = full ? 'less' : 'more'
  const getChildProps = spliter(props)

  return (
    <div className={style.item}>
      <div className={`${style.row} ${style['item-primary']}`}>
        <div> {index + 1} </div>
        <div><Select {...getChildProps('productRef')} /></div>
        { isLens ?
          <LensSpec {...getChildProps('lensSpec')} style={style} />
        : <div><Input {...getChildProps('productSpec')} /></div>
        }
        <div><Input {...getChildProps('unitPrice')} type="number" /></div>
        <div><Input {...getChildProps('qty')} type="number" /></div>
        <div>{value.subtotal}</div>
        <div><Input {...getChildProps('itemNote')} /></div>
        <div><button className="btn btn-primary" onClick={copy}>複製</button></div>
        <div>
          <button className="btn btn-link" onClick={toggleFullFeatures}>
            {toggleFullFeaturesBtn}
          </button>
        </div>
      </div>
      <div className={cx({ row: true, 'item-detail': true, hide: !full })}>
        <div>
          <div className={style.title}>折數: </div>
          <div className={style['input-container']}>
            <Input {...getChildProps('discount')} type="number" />
          </div>
        </div>
        <div>
          <button className="btn btn-danger" onClick={remove}>刪除</button>
        </div>
      </div>
    </div>
  )
}

ItemEditor.propTypes = {
  index: number.isRequired,
  value: object,
  spliter: func.isRequired,
  style: object.isRequired,
  copy: func.isRequired,
  remove: func.isRequired,
  toggleFullFeatures: func.isRequired,
  full: bool,
}


export default ItemEditor



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/ItemsEditor/ItemEditor/ItemEditor.jsx